import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		loadingBarStatus: false,
		loadingPage: false,
		subMenuItems: [],
		trendKeywords: [], // 인기검색어
		storageStatInfo: [],
    statisticsMap: {} //통계표 목록
	},
	getters: {
		findSubMenu: state => (id) => {
			return state.subMenuItems.find(item => item.id === id)
		},
		findAllSubMenu: state => () => {
			return state.subMenuItems
		},
		trendKeywords (state) {
			return state.trendKeywords
		},
		storageStatInfo (state) {
			return state.storageStatInfo
		},
    getStatistics: state => id => {
      return state.statisticsMap[id];
    }
	},
	mutations: {
		showLoadingBar (state) {
			state.loadingBarStatus = true
		},
		hiddenLoadingBar (state) {
			state.loadingBarStatus = false
		},
    updatePageLoadingBar (state, value) {
      state.loadingPage = value
    },
		addSubMenuItem (state, addSubMenuItems) {
			state.subMenuItems.push(addSubMenuItems)
		},
		trendKeywords (state, value) {
			state.trendKeywords.push(value)
		},
		storageStatInfo (state, value) {
			state.storageStatInfo = value
		},
    statistics(state, value) {
      const {id, items} = value
      state.statisticsMap[id] = items;
    }

	},
	actions: {
		addSubMenuItem ({ state, getters, commit }, { id, items }) {
			const findSubMenu = getters.findSubMenu(id)
			if (findSubMenu) {
				return
			}
			commit('addSubMenuItem', { id: id, items: items })
		},

		trendKeywords ({ state, getters, commit }, items) {
			commit('trendKeywords', items)
		}
	},
	modules: {
	},
	plugins: [
		createPersistedState({
      get storage() {

        if (process.env.NODE_ENV === 'development') {
          return {
            getItem: key => null,
            setItem: (key, value) => {},
            removeItem: key => {}
          }
        } else {
          return {
            getItem: key => window.sessionStorage.getItem(key),
            setItem: (key, value) => {
              //window.localStorage.setItem(key, value)
              window.sessionStorage.setItem(key, value) // 동시에 sessionStorage에도 저장
            },
            removeItem: key => {
              //window.localStorage.removeItem(key)
              window.sessionStorage.removeItem(key) // 동시에 sessionStorage에서도 제거
            }
          }
        }
      }
		})
	]

})
